const TMDB_IMAGE_BASE = "https://image.tmdb.org/t/p";

export function tmdbCardPosterUrl(posterPath) {
  if (!posterPath) return "";
  return `${TMDB_IMAGE_BASE}/w342${posterPath}`;
}

export function tmdbDetailPosterSources(posterPath) {
  if (!posterPath) return null;
  const p = posterPath;
  return {
    src: `${TMDB_IMAGE_BASE}/w342${p}`,
    srcSet: `${TMDB_IMAGE_BASE}/w185${p} 185w, ${TMDB_IMAGE_BASE}/w342${p} 342w, ${TMDB_IMAGE_BASE}/w500${p} 500w`,
    sizes: "(max-width: 640px) 50vw, 280px",
  };
}

export function tmdbCastAvatarUrl(profilePath) {
  if (!profilePath) return "";
  return `${TMDB_IMAGE_BASE}/w92${profilePath}`;
}
